import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-sso-logout',
  templateUrl: './sso-logout.component.html',
  styleUrls: ['./sso-logout.component.css']
})
export class SsoLogoutComponent implements OnInit {

  PrimaryMessage: string = "You are successfully logged out.";
  SecondaryMessage: string = "";
  queryParams: any;

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) {
    this.route.queryParams.subscribe(params => {
      let k = Object.keys(params)
      if (k.length > 0) {
        this.queryParams = params;
      }
    });
  }

  ngOnInit(): void {
   // alert("sso_Logout");
    // if (this.dataService.is_sso == true && this.queryParams != undefined && this.queryParams != null) {
    //   if (this.queryParams['issso'] == 'true') {
    //     this.PrimaryMessage = "User not exists.";
    //     this.SecondaryMessage = "You are not authorized to access the application.<br>Please contact Cognix support team.";
    //   }
    // }
  }

  // redirectToPage() {
  //   let url = this.dataService.sso_url;
  //   window.location.href=url;
  // }

  redirectToPage(page: string) {
    if (this.dataService.is_sso == true) {
     // this.router.navigate(['/sso-logout']);
      let url = this.dataService.sso_url;
      window.location.href = url;
    }
    else {
      this.router.navigate(['/login']);
    }
  }

}
